import React, {useEffect, useRef} from "react";
import {Button, message} from "antd";
import {YhForm} from "../../../../components/YhFormBox";
import {SettingOptModeEnum, useSettingModel} from "../settingModel";
import {FormItemTypeEnum, IYhFormRef} from "../../../../components/YhFormBox/Types";
import {branchDs} from "../../../../utils/constants";
import {settingService} from "../settingService";

export const FormBox = () => {
    const {selectedData, optMode, loadData} = useSettingModel();
    const formRef = useRef<IYhFormRef>();

    useEffect(() => {
        optMode === SettingOptModeEnum.ADD && formRef.current?.resetFields();
    }, [optMode]);

    const initialValues = optMode === SettingOptModeEnum.ADD ? {branch: "main"} : selectedData
    const formConfig = {
        formRef,
        labelCol: {span: 6},
        disabled: false,
        initialValues,
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "分支",
                fieldName: "branch",
                ds: branchDs,
                span: 24,
                disable: optMode !== SettingOptModeEnum.ADD,
                rules: [{required: true, message: "编码不能为空!"}]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "版本",
                fieldName: "ver",
                span: 24,
                disable: optMode !== SettingOptModeEnum.ADD,
                hidden: optMode === SettingOptModeEnum.ADD,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "启用",
                fieldName: "enable",
                span: 24,
                disable: optMode !== SettingOptModeEnum.ADD,
                hidden: optMode === SettingOptModeEnum.ADD,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "编码",
                fieldName: "code",
                span: 24,
                disable: optMode !== SettingOptModeEnum.ADD,
                rules: [{required: true, message: "编码不能为空!"}]

            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "值",
                fieldName: "value",
                span: 24,
                disable: false,
                rules: [{required: true, message: "值不能为空!"}]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
                disable: false,
            }
        ]
    }
    const onSave = async () => {
        try {
            const formData = await formRef.current?.validateFields();
            if (formData) {
                if (optMode === SettingOptModeEnum.ADD) {
                    const insertRet = await settingService.insert(formData);
                    if (insertRet.retData) {
                        message.success("新增成功!");
                        await loadData();
                    } else {
                        message.error("新增失败!" + insertRet.retMsg);
                    }
                }
                if (optMode === SettingOptModeEnum.EDIT) {
                    const updateRet = await settingService.update(formData);
                    if (updateRet.retData) {
                        message.success("修改成功!");
                        await loadData();
                    } else {
                        message.error("修改失败!" + updateRet.retMsg);
                    }
                }
            }
        } catch (e) {
            console.log("失败!");
        }
    }

    const onCancel = () => {
        formRef.current?.resetFields();
    }
    return (
        <div className="tree-form-box flex">
            <div className="tree-list-header">
                <Button type="link" shape="round" onClick={onSave}>保存</Button>
                <Button type="link" shape="round" onClick={onCancel}>重置</Button>
            </div>
            <div className="tree-form-content">
                <YhForm {...formConfig}/>
            </div>
        </div>
    )
}